import React from "react";
import "./TermsOfService.scss";

const TermsOfService = () => {
  return (
    <div className="TermsOfService">
      <div className="TermsOfService__holder">
        <div className="TermsOfService__title">
          <h2>TERMS OF SERVICE</h2>
          <p>Last updated: [17 July 2023]</p>
        </div>
        <div className="TermsOfService__descriptions">
          <p>
            Please read these Terms of Service ("Terms") carefully before using
            the services provided by BespokeCyber ("BespokeCyber," "We," "Us,"
            or "Our").
          </p>
          <ul>
            <li>
              <strong>Acceptance of Terms</strong>
              <p>
                By accessing or using the services provided by BespokeCyber, you
                agree to be bound by these Terms and all applicable laws and
                regulations. If you do not agree with any of these Terms, you
                may not use the services.
              </p>
            </li>
            <li>
              <strong>Description of Services</strong>
              <p>
                BespokeCyber provides [describe the services provided, e.g.,
                cybersecurity consulting and advisory services]. These services
                are subject to these Terms.
              </p>
            </li>
            <li>
              <strong>User Responsibilities</strong>
              <ul>
                <li>
                  <strong>3.1 Account Creation</strong>
                  <p>
                    To access certain features or services provided by
                    BespokeCyber, you may be required to create an account. You
                    are solely responsible for maintaining the confidentiality
                    of your account information, including your username and
                    password. You agree to provide accurate and up-to-date
                    information during the registration process and to notify
                    BespokeCyber promptly of any unauthorized use or suspected
                    security breach of your account.
                  </p>
                </li>
                <li>
                  <strong>3.2 Prohibited Conduct</strong>
                  <p>When using the services, you agree not to:</p>
                  <ul>
                    <li>Violate any applicable laws or regulations;</li>
                    <li>
                      Infringe upon the intellectual property rights of others;
                    </li>
                    <li>
                      Engage in any fraudulent, deceptive, or harmful
                      activities;
                    </li>
                    <li>Interfere with or disrupt the services or servers;</li>
                    <li>Impersonate any person or entity;</li>
                    <li>
                      Collect or store personal data about other users without
                      their consent;
                    </li>
                    <li>
                      Use the services for any unlawful, unethical, or
                      unauthorized purposes.
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              <strong>Intellectual Property</strong>
              <p>
                All intellectual property rights in the services provided by
                BespokeCyber, including but not limited to trademarks, logos,
                and content, belong to BespokeCyber or its licensors. You are
                granted a limited, non-exclusive, non-transferable right to use
                the services solely for your personal or internal business
                purposes. You may not reproduce, modify, distribute, or
                otherwise use any intellectual property without prior written
                consent from BespokeCyber.
              </p>
            </li>
            <li>
              <strong>Privacy Policy</strong>
              <p>
                Your use of the services is subject to our Privacy Policy, which
                outlines how we collect, use, and protect your personal
                information. By using the services, you consent to the
                collection and use of your information as described in the
                Privacy Policy.
              </p>
            </li>
            <li>
              <strong>Limitation of Liability</strong>
              <p>
                To the fullest extent permitted by applicable law, BespokeCyber
                and its affiliates, officers, directors, employees, and agents
                shall not be liable for any direct, indirect, incidental,
                consequential, or special damages arising out of or in any way
                connected with your use of the services or these Terms.
              </p>
            </li>
            <li>
              <strong>Termination</strong>
              <p>
                BespokeCyber reserves the right to suspend or terminate your
                access to the services at any time and for any reason, without
                prior notice. You may also terminate your use of the services at
                any time. Upon termination, your right to use the services will
                immediately cease, and you must cease all use of the services.
              </p>
            </li>
            <li>
              <strong>Modifications to Terms</strong>
              <p>
                BespokeCyber reserves the right to modify or update these Terms
                at any time, without prior notice. It is your responsibility to
                review these Terms periodically for any changes. By continuing
                to use the services after any modifications, you agree to be
                bound by the updated Terms.
              </p>
            </li>
            <li>
              <strong>Governing Law and Jurisdiction</strong>
              <p>
                These Terms shall be governed by and construed in accordance
                with the laws of Canada. Any disputes arising out of or relating
                to these Terms shall be subject to the exclusive jurisdiction of
                the courts located in Canada.
              </p>
            </li>
          </ul>
          <strong>Contact Us</strong>
          <p>
            If you have any questions or concerns about these Terms, you may
            contact us at{" "}
            <a href="mailto:info@bespokecyber.io">info@bespokecyber.io</a>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
